/**
 * SELECTION CARD TOKENS
 * Source: 🎨 Figma — components-rentals export
 */

import { type SemanticTokens, SEMANTIC } from '../semantic.js';

export function createSelectionCardTokens(s: SemanticTokens) {
  return {
  /** Base spacing for selection cards */
  base: {
    paddingX: s.layout.gap.sm,  // --selection-card-base-padding-x: var(--spacing-8)
    paddingY: s.layout.gap.sm,  // --selection-card-base-padding-y: var(--spacing-8)
    gap: s.layout.gap.sm,       // --selection-card-base-gap: var(--spacing-8)
    radius: s.radius.md,        // --selection-card-base-radius: var(--radius-8)
  },
  bgDefault: s.surface.ground,               // --selection-card-item-bg-default: var(--surface-ground)
  bgHover: s.surface.raised,                 // --selection-card-item-bg-hover: var(--surface-raised)
  bgPressed: s.interactive.secondary.subtleHover, // --selection-card-item-bg-pressed: var(--color-rentsody-100)
  bgActive: s.interactive.secondary.subtle,  // --selection-card-item-bg-active: var(--color-rentsody-50)
  bgDisabled: s.surface.disabled,            // --selection-card-item-bg-disabled: var(--surface-disabled)
  fgDefault: s.text.secondary,               // --selection-card-item-fg-default: var(--text-secondary)
  fgHover: s.text.secondary,                 // --selection-card-item-fg-hover: var(--text-secondary)
  fgPressed: s.text.secondary,               // --selection-card-item-fg-pressed: var(--text-secondary)
  fgActive: s.text.secondary,                // --selection-card-item-fg-active: var(--text-secondary)
  fgDisabled: s.text.secondary,              // --selection-card-item-fg-disabled: var(--text-secondary)
  border: s.border.default,                  // --selection-card-item-border: var(--border-default)
  };
}
export const selectionCardTokens = createSelectionCardTokens(SEMANTIC);